(() => {
  const SECTION_CLASS = 'shopify-section--gift-frequently-bought-products-renewal-base';

  const MEDIA_QUERY = window.matchMedia('(max-width: 768px)');

  const destroySlider = (slider) => {
    if (!slider || slider.dataset.splideMounted !== 'true') {
      return;
    }

    if (slider._splideInstance && typeof slider._splideInstance.destroy === 'function') {
      slider._splideInstance.destroy(true);
    }

    slider.dataset.splideMounted = 'false';
    slider._splideInstance = null;
  };

  const setupSlider = (slider) => {
    if (!slider) {
      return;
    }

    if (!MEDIA_QUERY.matches) {
      destroySlider(slider);
      return;
    }

    if (slider.dataset.splideMounted === 'true') {
      return;
    }

    if (typeof Splide === 'undefined') {
      return;
    }

    const splide = new Splide(slider, {
      perMove: 1,
      gap: '24px',
      fixedWidth: '300px',
      padding: {
        left: '64px',
        right: '64px',
      },
      speed: 600,
      rewind: true,
      rewindByDrag: true,
      arrows: true,
      pagination: true,
      breakpoints: {
        768: {
          gap: '16px',
          fixedWidth: '200px',
          padding: {
            left: '16px',
            right: '16px',
          },
        },
      },
    });

    splide.mount();
    slider.dataset.splideMounted = 'true';
    slider._splideInstance = splide;
  };

  const initSplides = (section) => {
    if (!section) {
      return;
    }

    section
      .querySelectorAll('.js-gift-products-splide')
      .forEach((slider) => {
        if (MEDIA_QUERY.matches) {
          setupSlider(slider);
        } else {
          destroySlider(slider);
        }
      });
  };

  const init = (section) => {
    if (!section) {
      return;
    }

    initSplides(section);

    if (section._giftFrequentlyBoughtMediaHandler) {
      return;
    }

    const handler = () => {
      initSplides(section);
    };

    if (MEDIA_QUERY.addEventListener) {
      MEDIA_QUERY.addEventListener('change', handler);
    } else if (MEDIA_QUERY.addListener) {
      MEDIA_QUERY.addListener(handler);
    }

    section._giftFrequentlyBoughtMediaHandler = handler;
  };

  const onReady = () => {
    document.querySelectorAll(`.${SECTION_CLASS}`).forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target;
    if (section && section.classList && section.classList.contains(SECTION_CLASS)) {
      init(section);
    }
  });
})();
